import { IOrderChangesHook } from '@models';
import { Order } from '@services';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useOrderChanges = (order: Order | undefined): IOrderChangesHook => {
  const { orderStore } = useStore();
  const { orderChanges, changeCurrentPage, changeSkipCount } = orderStore;

  useEffect(() => {
    order &&
      orderStore.getAllChanges({
        orderId: order.id,
        maxResultCount: 50,
        skipCount: changeSkipCount,
      });

    return () => orderStore.clearOrderChanges();
  }, [orderStore, order, changeSkipCount]);

  const handlePageChange = (pagination: any) => {
    orderStore.setChangeSkipCount((pagination.current - 1) * pagination.pageSize);
    orderStore.setChangeCurrentPage(pagination.current);
  };

  return {
    orderChanges: orderChanges.items,
    totalCount: orderChanges.totalCount,
    skipCount: changeSkipCount,
    currentPage: changeCurrentPage,
    maxResultCount: 50,
    handlePageChange,
  };
};
